import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/infor-warning.svg'
import _imports_1 from '@/assets/img/arrow-down.svg'


const _withScopeId = n => (_pushScopeId("data-v-02ea0221"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-flex-col tw-justify-center tw-items-start tw-self-stretch tw-p-[16px] md:tw-p-[40px] tw-bg-[#FFFFFF]" }
const _hoisted_2 = { class: "tw-flex tw-items-start tw-flex-col" }
const _hoisted_3 = { class: "tw-flex tw-items-center" }
const _hoisted_4 = { class: "tw-text-[#211F58] tw-text-[16px] tw-not-italic tw-font-semibold tw-leading-[130%] tw-pr-[10px]" }
const _hoisted_5 = { class: "tw-p-[25px]" }
const _hoisted_6 = { class: "tw-text-[14px] tw-font-[500] tw-text-[#211F58]" }
const _hoisted_7 = { class: "tw-text-[#878787] tw-text-[13px] tw-not-italic tw-font-normal tw-leading-[145%]" }
const _hoisted_8 = { class: "duplicate-wrap" }
const _hoisted_9 = { class: "duplicate-item" }
const _hoisted_10 = { class: "tw-text-[#231F20] tw-text-[14px] tw-not-italic tw-font-[500] tw-leading-[100%] tw-font-Poppins" }
const _hoisted_11 = { class: "duplicate-item" }
const _hoisted_12 = { class: "tw-text-[#231F20] tw-text-[14px] tw-not-italic tw-font-[500] tw-leading-[100%] tw-font-Poppins" }
const _hoisted_13 = { class: "duplicate-item" }
const _hoisted_14 = { class: "tw-text-[#231F20] tw-text-[14px] tw-not-italic tw-font-[500] tw-leading-[100%] tw-font-Poppins" }
const _hoisted_15 = { class: "duplicate-item" }
const _hoisted_16 = { class: "tw-text-[#231F20] tw-text-[14px] tw-not-italic tw-font-[500] tw-leading-[100%] tw-font-Poppins" }
const _hoisted_17 = { class: "tw-flex-1 tw-flex align-items-center" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_19 = { class: "advanced-section-heading-title" }
const _hoisted_20 = {
  key: 0,
  class: "advanced-section-icon-show",
  src: _imports_1
}
const _hoisted_21 = {
  key: 1,
  class: "advanced-section-icon-hidden",
  src: _imports_1
}
const _hoisted_22 = {
  key: 0,
  class: "advanced-section-form"
}
const _hoisted_23 = { class: "tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-mb-[5px]" }
const _hoisted_24 = { class: "tw-col-span-1 md:tw-col-span-1 tw-flex tw-items-center" }
const _hoisted_25 = { class: "advanced-section-form-field-title" }
const _hoisted_26 = { class: "tw-col-span-1 tw-mt-[10px] md:tw-mt-0 md:tw-col-span-1 tw-flex md:tw-justify-end" }
const _hoisted_27 = ["placeholder"]
const _hoisted_28 = { class: "tw-grid tw-grid-cols-1 md:tw-grid-cols-2" }
const _hoisted_29 = { class: "tw-col-span-1 md:tw-col-span-1 tw-flex tw-items-center" }
const _hoisted_30 = { class: "advanced-section-form-field-title" }
const _hoisted_31 = { class: "tw-col-span-1 tw-mt-[10px] md:tw-mt-0 md:tw-col-span-1 tw-flex md:tw-justify-end" }
const _hoisted_32 = ["placeholder"]
const _hoisted_33 = { class: "tw-flex tw-flex-row tw-justify-end tw-items-center tw-w-full tw-mt-[16px] md:tw-mt-[40px]" }

import { ref, watch, onMounted, PropType, Ref } from "vue";
import Modal from "@/components/common/modal.vue";
import ModalHeader from "@/components/common/modalHeader.vue";
import { getComponentUiText } from "@/utils/utilities";
import ButtonLoading from "../common/buttonLoading.vue";
import { showErrorAPI, showSuccessToast } from "@/services/apiRoutes";
import { Assessment } from "@/services/apiRoutes/routes";
import ButtonShowDuplicateAssessment from "../common/setting/buttonShowDuplicateAssessment.vue";
import { postDuplicateQuestion } from "@/services/assessment";
import store from "@/store";
import ToggleSwitch from "../common/toggleSwitch.vue";
import { successStatusCodes } from "@/utils/constants";
import get from "lodash/get";


export default /*#__PURE__*/_defineComponent({
  __name: 'duplicateQuestionModal',
  props: {
  show: {
    type: Boolean,
    required: false,
  },
  updateDataFucntion: {
    type: Function as PropType<(payload: any) => Promise<void>>,
    required: false,
    default: undefined,
  },
  checklistId: {
    type: String,
    required: true,
  },
  data: {
    type: Array as PropType<any[]>,
    required: false,
    default: () => [],
  },
},
  emits: ["update:show", "update:data", "update:success"],
  setup(__props, { emit }) {

const props = __props;



let showRef = ref(props.show);

const isLoading = ref(false);
const showAdvanced: Ref<boolean> = ref(false);
const duplicateAnswers: Ref<boolean> = ref(false);
const duplicateAttachments: Ref<boolean> = ref(false);
const duplicateGroups: Ref<boolean> = ref(false);
const setExcluded: Ref<boolean> = ref(false);

const description: Ref<string> = ref("");
const idPerTypeIdO2Type: Ref<string> = ref("");

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
  },
);

onMounted(() => {
  // autoResize();
});
const collapseCategory = () => (showAdvanced.value = !showAdvanced.value);



const handleCloseModal = async (isClickIcon = false) => {
  // if (!isClickIcon && (formModel.name || formModel.description)) return;

  showRef.value = false;
  emit("update:show", showRef.value);
};

const duplicateAssessment = async () => {
  try {
    isLoading.value = true;
    const checklistItems = props.data.map((item: any) => {
      return {
        checklistItemId: item.checklistItemId,
        duplicateAnswers: duplicateAnswers.value,
        duplicateAttachments: duplicateAttachments.value,
        duplicateGroups: duplicateGroups.value,
        setExcluded: setExcluded.value,
        ...(description.value != null &&
          description.value !== "" && { description: description.value }),
        ...(idPerTypeIdO2Type.value != null &&
          idPerTypeIdO2Type.value !== "" && {
            idPerTypeIdO2Type: idPerTypeIdO2Type.value,
          }),
      };
    });

    const body = {
      checklistId: props.checklistId,
      checklistItems: checklistItems,
    };

    const res = await postDuplicateQuestion(body);
    if (res.status !== successStatusCodes.OK) return;

    const newChecklist = get(res, "data.data.checklistItems", []);

    await store.dispatch("Assessment/updateChecklistAfterDuplicate", {
      checklistItems: newChecklist,
    });

    store.dispatch(
      "Assessment/fetchCheckListIdMetricsCompletion",
      props.checklistId,
    );

    store.dispatch(
      "Assessment/getChecklistMetricScoreCompletion",
      props.checklistId,
    );

    store.dispatch("Assessment/fetchCategories", {
      checklistId: props.checklistId,
      reload: false,
    });

    showSuccessToast(
      getComponentUiText(
        "app-component-assessment-duplicate-question-option-advanced-success-1",
      ),
    );

    emit("update:success", true);
    handleCloseModal();
  } catch (error: any) {
    showErrorAPI(error, Assessment.postDuplicateQuestion);
  } finally {
    isLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createBlock(Modal, {
    class: "tw-translate-y-[-50%] assessment-modal tw-max-w-[878px]",
    visible: _unref(showRef),
    "border-radius": "4px",
    onClose: handleCloseModal
  }, {
    default: _withCtx(() => [
      _createVNode(ModalHeader, {
        class: _normalizeClass(`modal-header`),
        title: 
        __props.data && __props.data.length === 1
          ? _unref(getComponentUiText)(
              'app-component-assessment-duplicate-question-modal-header-title-1',
            )
          : `${_unref(getComponentUiText)(
              'app-component-assessment-duplicate-questions-modal-header-title-1',
            )} (${__props.data.length})`
      ,
        onClose: _cache[0] || (_cache[0] = ($event: any) => (handleCloseModal(true)))
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(getComponentUiText)(
                "app-component-assessment-duplicate-question-modal-sub-title-1",
              )), 1),
            _createVNode(ButtonShowDuplicateAssessment, {
              "id-popover": __props.data[0].checklistItemId,
              "custom-class": 'tw-max-w-[470px]',
              classes: `tw-leading-[36px]`
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(getComponentUiText)(
                    "app-component-assessment-title-duplicate-1",
                  )), 1)
                ])
              ]),
              _: 1
            }, 8, ["id-popover"])
          ]),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(getComponentUiText)(
              __props.data && __props.data.length === 1
                ? "app-component-assessment-duplicate-question-modal-sub-des-1"
                : "app-component-assessment-duplicate-questions-modal-sub-des-1",
            )), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(getComponentUiText)(
                "app-component-assessment-duplicate-question-option-answers-1",
              )), 1),
            _createVNode(ToggleSwitch, {
              "is-checked": duplicateAnswers.value,
              "data-cy": `assessment-display-options-duplicate-item-1`,
              color: "#2573E9",
              "onUpdate:isChecked": _cache[1] || (_cache[1] = (value) => (duplicateAnswers.value = value))
            }, null, 8, ["is-checked"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(getComponentUiText)(
                "app-component-assessment-duplicate-question-option-attach-1",
              )), 1),
            _createVNode(ToggleSwitch, {
              "is-checked": duplicateAttachments.value,
              "data-cy": `assessment-display-options-2`,
              color: "#2573E9",
              "onUpdate:isChecked": _cache[2] || (_cache[2] = (value) => (duplicateAttachments.value = value))
            }, null, 8, ["is-checked"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(getComponentUiText)(
                "app-component-assessment-duplicate-question-option-recommen-1",
              )), 1),
            _createVNode(ToggleSwitch, {
              "is-checked": duplicateGroups.value,
              "data-cy": `assessment-display-options-2`,
              color: "#2573E9",
              "onUpdate:isChecked": _cache[3] || (_cache[3] = (value) => (duplicateGroups.value = value))
            }, null, 8, ["is-checked"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(getComponentUiText)(
                __props.data && __props.data.length === 1
                  ? "app-component-assessment-duplicate-question-option-exclude-1"
                  : "app-component-assessment-duplicate-questions-option-exclude-1",
              )), 1),
            _createVNode(ToggleSwitch, {
              "is-checked": setExcluded.value,
              "data-cy": `assessment-display-options-3`,
              color: "#2573E9",
              "onUpdate:isChecked": _cache[4] || (_cache[4] = (value) => (setExcluded.value = value))
            }, null, 8, ["is-checked"])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(`advanced-section ${
          showAdvanced.value ? `` : `advanced-section-open`
        }`)
        }, [
          _createElementVNode("div", {
            class: "advanced-section-heading",
            onClick: collapseCategory
          }, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(getComponentUiText)(
                  "app-component-assessment-duplicate-question-option-advanced-1",
                )), 1)
            ]),
            _createElementVNode("span", null, [
              (showAdvanced.value)
                ? (_openBlock(), _createElementBlock("img", _hoisted_20))
                : (_openBlock(), _createElementBlock("img", _hoisted_21))
            ])
          ]),
          (showAdvanced.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(getComponentUiText)(
                  "app-component-assessment-duplicate-question-advanced-field-1",
                )), 1)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((description).value = $event)),
                      placeholder: 
                  _unref(getComponentUiText)(
                    'app-component-assessment-duplicate-question-option-advanced-des-placeholder-1',
                  )
                ,
                      class: _normalizeClass(`advanced-section-form-input tw-w-auto lg:tw-w-[346px]`)
                    }, null, 8, _hoisted_27), [
                      [_vModelText, description.value]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(getComponentUiText)(
                  "app-component-assessment-duplicate-question-option-advanced-update-org-1",
                )), 1)
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((idPerTypeIdO2Type).value = $event)),
                      placeholder: 
                  _unref(getComponentUiText)(
                    'app-component-assessment-duplicate-question-option-advanced-update-org-placeholder-1',
                  )
                ,
                      class: _normalizeClass(`advanced-section-form-input tw-w-auto lg:tw-w-[346px]`)
                    }, null, 8, _hoisted_32), [
                      [_vModelText, idPerTypeIdO2Type.value]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", _hoisted_33, [
          _createVNode(_component_b_button, {
            variant: "primary",
            class: "tw-w-fit tw-h-[39px] tw-mr-[15px] tw-shadow-none tw-bg-[#fff] tw-text-[#387DFF] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px] tw-border-2 tw-border-solid hover:!tw-border-[#0069d9]",
            type: "submit",
            onClick: handleCloseModal
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
              "app-component-assessment-duplicate-assessment-modal-button-cancel-1",
            )), 1)
            ]),
            _: 1
          }),
          _createVNode(ButtonLoading, {
            title: 
            _unref(getComponentUiText)(
              'app-component-assessment-duplicate-assessment-modal-button-duplicate-1',
            )
          ,
            "is-loading": isLoading.value,
            onClickAction: duplicateAssessment
          }, null, 8, ["title", "is-loading"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})